import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type GetIcpProductCategoriesV1IcpProductCategoriesGetData,
  type GetIcpProductCategoriesV1IcpProductCategoriesGetError,
  type GetIcpProductCategoriesV1IcpProductCategoriesGetResponse,
  getIcpProductCategoriesV1IcpProductCategoriesGet,
} from '../../generated';

export type GetIcpProductCategoriesQueryVariables = NonNullable<
  GetIcpProductCategoriesV1IcpProductCategoriesGetData['query']
>;

export type GetIcpProductCategoriesQuery = GetIcpProductCategoriesV1IcpProductCategoriesGetResponse;

export const useGetIcpProductCategoriesQuery = <
  TData = GetIcpProductCategoriesQuery,
  TError = GetIcpProductCategoriesV1IcpProductCategoriesGetError,
>(
  { limit, offset, retailer_region_id, sort_by, sort_direction }: GetIcpProductCategoriesQueryVariables,
  options?: Omit<UseQueryOptions<GetIcpProductCategoriesQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<GetIcpProductCategoriesQuery, TError, TData>({
    queryKey: ['GetIcpProductCategories', { limit, offset, retailer_region_id, sort_by, sort_direction }],
    queryFn: async () => {
      const { data } = await getIcpProductCategoriesV1IcpProductCategoriesGet({
        query: { limit, offset, retailer_region_id, sort_by, sort_direction },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useGetIcpProductCategoriesQuery.getKey = ({
  limit,
  offset,
  retailer_region_id,
  sort_by,
  sort_direction,
}: GetIcpProductCategoriesQueryVariables) => [
  'GetIcpProductCategories',
  { limit, offset, retailer_region_id, sort_by, sort_direction },
];

useGetIcpProductCategoriesQuery.fetcher = (
  { limit, offset, retailer_region_id, sort_by, sort_direction }: GetIcpProductCategoriesQueryVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await getIcpProductCategoriesV1IcpProductCategoriesGet({
      query: { limit, offset, retailer_region_id, sort_by, sort_direction },
      throwOnError: true,
    });
    return data;
  };
};
